import { useVolunteeringConfirmVolunteeringRecord } from "@crowdcoursing/api/openapi";
import { useCallback } from "react";

interface UseVolunteeringConfirmationProps {
  onSuccess?: () => void;
}

export const useVolunteeringConfirmation = ({ onSuccess }: UseVolunteeringConfirmationProps = {}) => {
  const { mutate: confirmVolunteering, isPending } = useVolunteeringConfirmVolunteeringRecord({
    onSuccess: () => {
      onSuccess?.();
    },
  });

  const handleConfirm = useCallback(
    (volunteeringRecordId: string) => {
      confirmVolunteering({
        pathParams: {
          volunteeringRecordId,
        },
      });
    },
    [confirmVolunteering],
  );

  return {
    confirmVolunteering: handleConfirm,
    isConfirming: isPending,
  };
};
